export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=705ae62cf38fff482242b3ecc018c0b0d511a109cc&name=pushAdClickData!'